let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("in5qk")).then(() => parcelRequire('2iJQj'));